export const KEYS = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '{backspace}'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l'],
    ['{shift}', 'z', 'x', 'c', 'v', 'b', 'n', 'm', '{shift}'],
    ['{specialChar}', '.com', '{space}', '@', '.', '{enter}'],
]
export const KEYS_NAM_ENTRY = [
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '{backspace}'],
    ['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'],
    ['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'],
    ['Z', 'X', 'C', 'V', 'B', 'N', 'M']
]
export const NUMPAD = [
    ['7', '8', '9'], ['4', '5', '6'], ['1', '2', '3'], ['0', '{backspace}']
]
export const SPECIAL_KEYS = [
    ['[', ']', '{', '}', '#', '%', '^', '*', '+', '=', , '{backspace}'],
    ['-', '/', ':', ';', '(', ')', '$', '&', '@', '"', "_"],
    ['\\', '|', '~', 'à', 'á', 'â', 'è', 'é', 'ê', 'ë', 'î',],
    [, 'ô', 'ó', 'ú', 'ü', 'û', 'ù', 'ñ', 'ç', 'ï', 'í'],
    ['{shift}', '...', '.', ',', '?', '!', "'", '_', '$', '¿', '¡', '{shift}'],
    ['{ABC}', '.com', '{space}', '@', '{enter}']
]
export const SPECIAL_CHARACTER = ['-', '=', '`', ';', "'", ',', '.', '/', '[', ']', '\\'];

export const KEYBOARD_LANGUAGE = {
    FR: {
        default: ['à', 'è', 'ù', 'é', 'â', 'ê', 'î', 'ô', 'û', 'ë', 'ï', 'ü', 'ç', '{lang}'],
        shift: ['À', 'È', 'Ù', 'É', 'Â', 'Ê', 'Î', 'Ô', 'Û', 'Ë', 'Ï', 'Ü', 'Ç', '{lang}']
    },
    ES: {
        default: ['á', 'é', 'í', 'ó', 'ú', 'ü', 'ñ', '¿', '¡', '{lang}'],
        shift: ['Á', 'É', 'Í', 'Ó', 'Ú', 'Ü', 'Ñ', '¿', '¡', '{lang}']
    }
}


// WEBPACK FOOTER //
// ./src/components/KeyboardKiosk/Constants.ts